
var stache = require('can/view/stache/stache');
module.exports = stache("<li class=\"s-list__item\">\r\n    <span class=\"s-num\">\r\n        <span class=\"s-num__item\">{{exemptionNumber}}</span>\r\n    </span>\r\n    <span class=\"s-desc\">{{title}}</span>\r\n</li>");